import { imageProps } from '../../imageAssets';
import { Col, Container, Row } from 'react-bootstrap';
import { FaFacebook, FaTiktok, FaYoutube } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Style from "./style.module.css";

export default function Footer() {
    const theme = useSelector((state) => state.theme.mode);
    const logo = theme === 'dark' ? 'logoWhite' : 'logoBlack';

    return (
        <footer className={Style.footer}>
            <div className={Style.footerGlowLine}></div>
            <div className={Style.footerGlowSpot}></div>
            <Container>
                <Row className={`align-items-center ${Style.footerContent}`}>
                    {/* Logo & Description Column (Right side in RTL) */}
                    <Col lg={4} md={12} className={`${Style.footerCol} ${Style.logoCol}`}>
                        <div className={Style.logoSection}>
                            <img {...imageProps(logo)} alt="المهندس" loading="lazy" className={Style.footerLogo} />
                            <p className={Style.footerDescription}>
                                تم صنع هذه المنصة بهدف تهيئة الطالب لـ كامل جوانب الثانوية العامة و ما بعدها
                            </p>
                            <div className={Style.devCredit}>
                                <a
                                    href='https://www.facebook.com/hassan.fathy.749426'
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    className={Style.devLink}
                                >
                                    Developed by Eng. Hassan Fathy
                                </a>
                            </div>
                            <div className={Style.copyrightPill}>
                                <span>جميع الحقوق محفوظة © 2026</span>
                            </div>
                        </div>
                    </Col>

                    {/* Pages Column (Center) */}
                    <Col lg={4} md={6} className={`${Style.footerCol} ${Style.pagesCol}`}>
                        <div className={Style.pagesWrapper}>
                            <h4 className={Style.footerTitle}>الصفحات</h4>
                            <ul className={Style.pagesList}>
                                <li>
                                    <Link to="/" className={Style.pageLink}>
                                        <span className={Style.pageLinkDot}></span>
                                        الرئيسية
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/register" className={Style.pageLink}>
                                        <span className={Style.pageLinkDot}></span>
                                        انشاء حساب جديد
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/login" className={Style.pageLink}>
                                        <span className={Style.pageLinkDot}></span>
                                        تسجيل الدخول
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    {/* Social Media Column (Left side in RTL) */}
                    <Col lg={4} md={6} className={`${Style.footerCol} ${Style.socialCol}`}>
                        <div className={Style.socialWrapper}>
                            <h4 className={Style.footerTitle}>السوشيال ميديا</h4>
                            <ul className={Style.socialList}>
                                <li>
                                    <a
                                        href='https://www.facebook.com/profile.php?id=100089169812580'
                                        target='_blank'
                                        rel="noopener noreferrer"
                                        className={`${Style.socialLink} ${Style.facebook}`}
                                    >
                                        <FaFacebook className={Style.socialIcon} style={{ color: '#1877f2' }} />
                                        <span>فيسبوك</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href='https://www.tiktok.com/@mr.mohamed.yousse/'
                                        target='_blank'
                                        rel="noopener noreferrer"
                                        className={`${Style.socialLink} ${Style.tiktok}`}
                                    >
                                        <FaTiktok className={Style.socialIcon} />
                                        <span>تيك توك</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href='https://www.youtube.com/@-bm2cz'
                                        target='_blank'
                                        rel="noopener noreferrer"
                                        className={`${Style.socialLink} ${Style.youtube}`}
                                    >
                                        <FaYoutube className={Style.socialIcon} style={{ color: '#FF0000' }} />
                                        <span>يوتيوب</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

